export default __webpack_public_path__ + "static/media/img-0267-saudi-arabia-half-face.c1625f82.png";